import React from "react";
import { Typography } from "@mui/material";
import TranslationContent from "../../../../Translations/TranslationContent";


const InvalidNumber = () => {
  return <Typography sx={{color: "black"}} variant="body2"><TranslationContent contentID="invalidNumberDesc" /></Typography>
}

export default InvalidNumber;